import styled from 'styled-components';

export const RuleBuilder = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  min-height: 3rem;

  .draggingPlaceholder {
    background-color: ${(props): string => props.theme.colors.iceGray};
    position: absolute;
  }
`;
